export default "__VITE_ASSET__4lVcgtEF__"